(function(angular){
	'use strict';
	
	angular
		.module('investorDashboard')
		.controller('AccountOverviewController', [
			'$cookies',
			'$filter',
			'$rootScope',
			'$scope',
			'$timeout',
			'$window',
			'APP_BASE_PATH',
			'Big',
			'investmentGoalFactory',
			'globalConfig',
			'InvestmentEntityFactory',
			'localStorageFactory',
			'mixpanelFactory',
			'PropertyService',
			'ReitElementFactory',
			'ServiceLevelFactory',
			'smoothScroll',
			'urlFactory',
			InvestorDashboardCtrl
		]);
	
	function InvestorDashboardCtrl(
		$cookies,
		$filter,
		$rootScope,
		$scope,
		$timeout,
		$window,
		APP_BASE_PATH,
		Big,
		investmentGoalFactory,
		globalConfig,
		InvestmentEntityFactory,
		localStorageFactory,
		mixpanelFactory,
		PropertyService,
		ReitElementFactory,
		ServiceLevelFactory,
		smoothScroll,
		urlFactory
	) {
		var dashboard = this;
		var hasIpo = globalConfig.hasEverOwnedIpoShares;
		var canLoadNextPage = false;
		var topRailElement;

		dashboard.$onInit = function() {
			dashboard.currentChartTab = localStorageFactory.getItem('currentChartTab') || 'goal';
			dashboard.basePath = APP_BASE_PATH;

			dashboard.address = globalConfig.address;
			dashboard.showMissingBeneficiariesAlert = false;
			dashboard.ratingAllocations = globalConfig.ratingAllocations;
			dashboard.assetTileDtos = globalConfig.assetTileDtos;
			dashboard.investmentEntityId = globalConfig.investmentEntityId;
			dashboard.assetTileDtosFormatted = PropertyService.formatPropertyList(dashboard.assetTileDtos);
			dashboard.hasLegacyInvestments = globalConfig.hasLegacyInvestments;
			dashboard.showIpoModal = globalConfig.showIpoModal;
			dashboard.canShowAddressModal = globalConfig.canShowAddressModal;
			dashboard.riaPlanName = globalConfig.riaPlanName;
			dashboard.dripEnabled = globalConfig.dripEnabled;
			dashboard.newsFeedIsLoading = true;
			dashboard.newsFeedFiltersLoading = true;
			dashboard.shouldShowServiceLevel = false;
			dashboard.showFundMtcModal = globalConfig.showFundMtcModal;
			topRailElement = angular.element($window.document.getElementById('top-rail'));

			ReitElementFactory.getReitElementListsForDashboard()
				.then(function(reitElementLists) {
					angular.extend(dashboard, reitElementLists);
				});

			showModals();

			if (angular.isDefined(globalConfig.futureEarnings)) {
				getFutureEarningsData();
			}

			getPerformanceData();
			getNewsFeedData();
			setServiceLevelInfo();
		};

		function getPerformanceData() {
			InvestmentEntityFactory.getPerformanceData()
				.then(function(performanceData) {
					dashboard.performance = {
						eligibilityStatus: performanceData.performanceEligibilityStatus
					};
					dashboard.investorSince = performanceData.investorSince;
					
					if(angular.isDefined(performanceData.accountValueChangeSinceLastLogin) && performanceData.accountValueChangeSinceLastLogin !== '0.00') {
						mixpanelFactory.track('Earnings Since Last Login Shown', {
							'Amount': performanceData.accountValueChangeSinceLastLogin
						});
						dashboard.accountValueChangeSinceLastLogin = performanceData.accountValueChangeSinceLastLogin;
						dashboard.accountValuePositive = Big(dashboard.accountValueChangeSinceLastLogin).gt(Big(0));
						dashboard.accountValueIcon = dashboard.accountValuePositive ? 'caret-up' : 'caret-down';
					}

					if((performanceData.performanceEligibilityStatus === 'HAS_PERFORMANCE' || performanceData.performanceEligibilityStatus === 'LESS_THAN_FULL_QUARTER') && angular.isDefined(performanceData.accountBreakdown)) {
						dashboard.totalAccountValue = performanceData.accountBreakdown.allTimePerformance.endingValue;
						dashboard.performance.hasRedemptions = performanceData.accountBreakdown.hasDistributedRedemptions;
						dashboard.performance.allTime = {
							dividendsEarned: performanceData.accountBreakdown.allTimePerformance.dividendsEarned,
							appreciation: performanceData.accountBreakdown.allTimePerformance.appreciation,
							advisoryFees: performanceData.accountBreakdown.allTimePerformance.advisoryFees,
							netEarnings: performanceData.accountBreakdown.allTimePerformance.netEarnings
						};
						if(angular.isDefined(performanceData.accountBreakdown.allTimePerformance.redemptionFees)) {
							dashboard.performance.allTime.redemptionFees = performanceData.accountBreakdown.allTimePerformance.redemptionFees;
						}
						if(angular.isDefined(performanceData.accountBreakdown.currentYearPerformance)) {
							dashboard.performance.currentYear = {
								year: performanceData.accountBreakdown.currentYear,
								dividendsEarned: performanceData.accountBreakdown.currentYearPerformance.dividendsEarned,
								appreciation: performanceData.accountBreakdown.currentYearPerformance.appreciation,
								advisoryFees: performanceData.accountBreakdown.currentYearPerformance.advisoryFees,
								netEarnings: performanceData.accountBreakdown.currentYearPerformance.netEarnings
							};
							if(angular.isDefined(performanceData.accountBreakdown.currentYearPerformance.redemptionFees)) {
								dashboard.performance.currentYear.redemptionFees = performanceData.accountBreakdown.currentYearPerformance.redemptionFees;
							}
						}
					} else if(performanceData.performanceEligibilityStatus === 'NO_SETTLED_INVESTMENTS') {
						dashboard.totalAccountValue = 0;
					}

					dashboard.accountValueChartPlaceholderMessage = getAccountValueChartPlaceholderMessage();
					dashboard.performance.loaded = true;
			});
		}

		function getNewsFeedData() {
			InvestmentEntityFactory.newsfeed.getFirstPage()
				.then(function(response) {
					dashboard.newsFeedItems = response.data;
					$timeout(function() {
						dashboard.newsFeedIsLoading = false;
						canLoadNextPage = true;
					});
				}, function(response) {
					dashboard.newsFeedItems = response.data;
					canLoadNextPage = true;
					dashboard.newsFeedIsLoading = false;
				});

			setupNewsFeedFilters();
		}

		function setupNewsFeedFilters() {
			dashboard.newsFilters = [{
				label: 'Everything',
				sortKey: 'everything',
				active: true
			},{
				label: 'Projects',
				sortKey: 'assets',
				active: false,
				enumToFilter: [
					'INVESTOR_UPDATE_ASSET_ACQUISITION',
					'INVESTOR_UPDATE_ASSET_EXIT',
					'INVESTOR_UPDATE_ASSET_OTHER'
				]
			},{
				label: 'Dividends',
				sortKey: 'dividends',
				active: false,
				enumToFilter: [
					'REIT_DIVIDEND'
				]
			}];

			if(hasIpo) {
				dashboard.newsFilters.push({
					label: 'Fundrise iPO',
					sortKey: 'ipo',
					active: false,
					enumToFilter: [
						'INVESTOR_UPDATE_IPO'
					]
				});
			}
			dashboard.newsFeedFiltersLoading = false;
		}

		function getNextPage() {
			InvestmentEntityFactory.newsfeed.getNextPage()
				.then(function(response) {
					dashboard.newsFeedItems = dashboard.newsFeedItems.concat(response.data);
					dashboard.newsFeedNextPage = response.meta.nextPage;

					if(angular.isDefined(dashboard.newsFeedNextPage)) {
						canLoadNextPage = true;
					}
					dashboard.newsFeedIsLoading = false;
				})
				.catch(function(response) {
					dashboard.newsFeedNextPage = undefined;
					dashboard.newsFeedIsLoading = false;
				});
		}

		function getAccountValueChartPlaceholderMessage() {
			var accountValueChartPlaceholderMessage;

			if (dashboard.hasLegacyInvestments) {
				accountValueChartPlaceholderMessage = 'No data available for eDirect investments.';
			} else {
				accountValueChartPlaceholderMessage = 'Data will become available one week after your first order completes.';
			}

			return accountValueChartPlaceholderMessage;
		}

		function getFutureEarningsData() {
			investmentGoalFactory.getInvestmentGoalData(
				'EXISTING_GOAL',
				globalConfig.futureEarnings.plan,
				globalConfig.futureEarnings.goal,
				globalConfig.futureEarnings.months,
				globalConfig.futureEarnings.amount,
				globalConfig.futureEarnings.autoInvestFrequency,
				globalConfig.futureEarnings.dripEnabled
			)
			.then(function(data) {
				var pointWhereGoalAchieved = $filter('filter')(data.chartData, { expectedGoalAchievedDate: true })[0];
				var indexWhereGoalAchieved = data.chartData.indexOf(pointWhereGoalAchieved);

				dashboard.chartData = data.chartData.slice(0, indexWhereGoalAchieved + 1);
				dashboard.goalStartDate = data.goalStartDate;
				dashboard.percentToGoal = data.percentageOfCurrentAmountToGoalAmountAtEndOfGoalTimeline;
				dashboard.investmentGoalState = data.investmentGoalState;
				dashboard.monthlyAutoInvestAmount = data.monthlyAutoInvestAmount;
				dashboard.monthlyGoalExpectedInvestmentAmount = data.monthlyGoalExpectedInvestmentAmount;
				dashboard.lastDayOfCurrentMonth = data.lastDayOfCurrentMonth;
				dashboard.showGoalSeries = dashboard.percentToGoal > 103 || dashboard.percentToGoal < 97;
				dashboard.totalPrincipalInvestedThisMonth = Number(Big(data.totalPrincipalInvestedThisMonth));
				dashboard.additionalPaymentSuggestedByEndOfMonth = Number(Big(data.additionalPaymentSuggestedByEndOfMonth));
				dashboard.remainingAmountNeeded = dashboard.additionalPaymentSuggestedByEndOfMonth - dashboard.totalPrincipalInvestedThisMonth;
				dashboard.earningsProjection = pointWhereGoalAchieved.currentAmount;
			})
			.catch(function(response){
				urlFactory.handleFailedRequest(response);
			});
		}

		function setServiceLevelInfo() {
			ServiceLevelFactory.getCurrentServiceLevel()
				.then(function(currentServiceLevel) {
					dashboard.currentServiceLevel = currentServiceLevel;
					setShouldShowServiceLevel();
				});
		}

		function showModals() {
			var ipoCookieKey = 'com.fundrise.viewed_dashboard_ipo_modal_20180813';
			var hasSeenIpoModal = $cookies.get(ipoCookieKey);

			if (dashboard.showIpoModal && angular.isUndefined(hasSeenIpoModal)) {
				$scope.activeModal = 'unlock-ipo';
			
				$cookies.putObject(ipoCookieKey, true, {
					'secure': true,
					'path': '/'
				});
			} else if(dashboard.canShowAddressModal) {
				dashboard.showAddressModal = true;
			}
		}

		function setShouldShowServiceLevel() {
			if (dashboard.currentServiceLevel.name === 'STARTER' || dashboard.currentServiceLevel.name === 'CORE' || dashboard.currentServiceLevel.name === 'ADVANCED' || dashboard.currentServiceLevel.name === 'PREMIUM') {
				dashboard.shouldShowServiceLevel = true;
			}
		}

		dashboard.changeChartSelection = function(selectedTab){
			dashboard.currentChartTab = selectedTab;
			localStorageFactory.setItem('currentChartTab', selectedTab);
		};

		dashboard.filterNews = function(selectedFilter) {
			canLoadNextPage = false;
			dashboard.newsFeedIsLoading = true;

			InvestmentEntityFactory.newsfeed.getFirstPage({ filters: selectedFilter.enumToFilter })
				.then(function(response) {
					mixpanelFactory.track('Dashboard Filter News Feed', {
						'Filter By': selectedFilter.label
					});

					smoothScroll(topRailElement[0], {
						duration: 400
					});

					dashboard.newsFeedItems = response.data;

					$timeout(function() {
						dashboard.newsFeedIsLoading = false;
						canLoadNextPage = true;
					}, 400);
				}
			);

			angular.forEach(dashboard.newsFilters, function(filter) {
				filter.active = false;
			});

			selectedFilter.active = true;
		};
		
		dashboard.handleUnfundedMtc = function() {
			var leavingFundriseData = {
				text: "If you wish to place additional investments on our platform, you will first need to add funds to your IRA. By clicking the link below, you will be redirected to Millennium Trust Company\'s website to fund your IRA."
			};
			
			$rootScope.ModalFactory.openLeavingFundrise(leavingFundriseData)
				.then(function(modal) {
					modal.close.then(function(result) {
						if (result && result.success) {
							urlFactory.redirectNewTab('https://portal2.mtrustcompany.com/millennium/servlet/SmartForm.html?formCode=verification-form&disableInvestment=true&refCode=RIS&data=true');
						}
					});
				});
		};

		$scope.$on('infinite-scroll', function() {
			if(canLoadNextPage) {
				canLoadNextPage = false;
				dashboard.newsFeedIsLoading = true;
				getNextPage();
			}
		});
	}
})(window.angular);